<template>
  <div class="card">
    <h1 class="am-text-center">不要看这里！这里没有文章呐！</h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "NotFound",
  computed: {
    ...mapGetters([ 'option' ])
  },
  watch: {
    option () {
      document.title = `页面没找到｜${this.option.title}`
      document.querySelector('meta[name="description"]').setAttribute('content', this.option.description)
      document.querySelector('meta[name="keywords"]').setAttribute('content', this.option.keywords)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue